<!--Page Liste des audits-->


<template>
	<dashboard-main-layout>
		<appbar-bordered>
			<!-- Columns selector -->
			<div v-if="installations.length > 0">
				<template>
					<v-btn color="white dark--text text-none" dark elevation="0" @click.stop="showSelectionGroup = true"
						class="mx-5">
						{{ $t('_colonnes_a_afficher_') }} ({{ selectedColumns.length }})
					</v-btn>

					<v-dialog v-model="showSelectionGroup" max-width="490">
						<v-card>
							<div class="d-flex flex-wrap">
								<div v-for="(group, index) in groups" :key="index" class="col-6">
									<template>
										<v-container class="px-0" fluid @click="toggleGroupSelection(index, $event)">
											<input type="checkbox" :checked="isGroupSelected(index) ? 'true' : ''" />
											<strong class="ml-1"
												:class="isGroupSelected(index) ? 'blue--text' : 'dark--text'">
												{{ $t(group) }}
											</strong>
										</v-container>
									</template>
									<div v-for="(column, index) in getColumns(index)" :key="index" class="ml-5">
										- {{ $t(column.text) }}
									</div>
								</div>
							</div>
						</v-card>
					</v-dialog>
				</template>
			</div>

			<v-btn style="margin-left: auto;" @click="toggleCreate">
				{{ $t('_creer_audit_') }}
			</v-btn>

		</appbar-bordered>

		<PopUpGetBrouillon v-if="this.openCreate" @close="toggleCreate" @new="toggleModal" @use="useDraft($event)">
		</PopUpGetBrouillon>
		<PopUpCreation v-if="this.createAudit" :data="this.dataToGive" @close="toggleModal"
			:type="'create'"></PopUpCreation>
		<PopUpCreation v-if="this.modifier" :installAModif="this.installId" @close="closeModify"
			:type="'modifier'"></PopUpCreation>

		<!-- Tableau -->
		<div class="pa-4">
			<v-card v-if="installations !== undefined && installations.length > 0" elevation="0">
				<v-card-title>
					<v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('_recherche_')" single-line
						hide-details></v-text-field>
				</v-card-title>
			</v-card>

			<v-data-table :headers="selectedColumnsOrdered" :items="installations" :loading="loading" item-key="id"
				show-select :footer-props="{
					'items-per-page-options': [20, 50, 100, -1]
				}" :items-per-page="20" id="level-1-table" :search="search" v-if="installationsShowable">

				<template v-slot:header.data-table-select="{ on, props }">
					<div class="d-flex justify-center" style="cursor: pointer" @click="toggleSelectAll()">
						<!-- JTS : Bug on checkbox audit group-->
						<input type="checkbox" :checked="areSelected" />
						<!-- :disabled="areSelected"  -->
					</div>
				</template>

				<template v-slot:body="{ items }">
					<tbody>
						<tr v-for="(item, index) in items" :key="item.id" :class="{ 'disabled': item.is_forbidden }">
							<td>
								<div class="d-flex justify-center" style="cursor: pointer"
									@click="toggleInstallation(index)">
									<input type="checkbox" v-model="installations[index].checked" />
								</div>
							</td>

							<td v-for="column in selectedColumnsOrdered" :key="column.key" :style="isFirstColumnOfGroup(column)
									? 'border-left:1px solid lightgray; cursor: pointer'
									: 'cursor: pointer'
								" @click="goToInstallation(item, column.key)">
								<installation-field :column="column.key" :item="item"
									v-if="column.key !== undefined && column.key !== 'actions' && column.key !== 'rapport'" />

								<div v-else>
									<div v-if="item.pdf_link.length > 0">
										<a href="#" target="_blank" @click.prevent="getPDF(item.pdf_link)"
											style="cursor: pointer">
											<v-icon>
												mdi-download-box
											</v-icon>
										</a>
									</div>
									<div>
										<v-btn @click="openModify(item,column.key)">{{ $t('_modifier_') }}</v-btn>
									</div>
								</div>
							</td>

						</tr>
					</tbody>
				</template>
			</v-data-table>
		</div>
	</dashboard-main-layout>
</template>

<script>
// Components
import DashboardMainLayout from "../../layouts/Dashboard/MainLayout";
import InstallationField from "../../components/Table/InstallationField";
import AppbarBordered from "../../components/Utils/AppbarBordered";
import { mapMutations } from "vuex";
import api from "../../api/api";
import { mapGetters } from "vuex";
import webconf from "../../utils/frontend_setup"
import PopUpCreation from "@/components/Creation/PopUpCreation.vue";
import PopUpGetBrouillon from "@/components/Creation/PopUpGetBrouillon.vue";


export default {
	components: {
		DashboardMainLayout,
		AppbarBordered,
		InstallationField,
		PopUpCreation,
		PopUpGetBrouillon,
	},

	data() {
		return {
			script_name: "Main.vue (Dashboard Niv1)",        // For debug
			loading: false,
			target_menu: "",
			hoverInstallation: false,
			selectedColumns: [],
			showReportLink: false,
			showSelectionGroup: false,
			// showInstallationOtherColumnsMenu: false,
			search: "",
			createAudit: false,
			openCreate: false,
			dataToGive: null,
			modifier: false,
			installId: null
		};
	},

	watch: {
		'$route': {
			handler() {
				this.$store.commit("SET_CUR_INSTALL_ID", null)
			},
			immediate: true,
			deep: true,
		},

		selectedGroups: {
			handler(val) {
				if (this.constants.columns)
					this.selectedColumns =
						this.constants.columns.filter((column) =>
							val.includes(column.group)
						);
			},
			immediate: true,
		},
	},

	computed: {
		...mapGetters(["cur_install_id"]),

		constants() {
			webconf.debugLog('computed', this.script_name, 'constants',
				this.$store.getters.constants
			)
			return this.$store.getters.constants;
		},

		installationsShowable() {
			return this.installations
				&& Array.isArray(this.installations)
				&& this.selectedColumnsOrdered
				&& this.selectedColumnsOrdered.length
		},

		groups() {
			// Build group list
			const groupList = this.constants.columns.filter((group) =>
				group.show_dashboard.includes(this.target_menu)
			).map((column) => column.group)

			const columns_group = this.constants ? this.constants.columns_group : []

			let res = {}
			columns_group.forEach(column_group => {
				if (groupList.includes(column_group.key)) {
					res[column_group.key] = column_group.title
				}
			})
			return res
		},

		selectedColumnsOrdered() {
			if (!this.selectedColumns || !this.selectedColumns.length) return []
			else {
				return this.$_.orderBy(this.selectedColumns, ['index'], ['asc']).map(c => {
					return {
						...c,
						...{
							text: this.$t(c.text),
							value: c.key
						}
					}
				})
			}
		},

		unselectedColumns() {
			return this.constants.columns.filter(
				(x) => !this.selectedColumns.includes(x)
			);
		},

		installations: {
			get() {
				return this.$store.getters.installations
			},
			set(value) {
				this.$store.commit("SET_INSTALLATIONS", value)
			},
		},

		selectedGroups: {
			get() {
				return this.$store.state.parametersStore.installations_groups
			},
			set(value) {
				this.$store.commit("SET_INSTALLATIONS_GROUPS", value)
			},
		},

		areSelected() {
			return !this.installations.filter((installation) => !installation.checked).length;
		},

		dates() {
			webconf.debugLog('computed', this.script_name, 'constants',
				this.$store.state.parametersStore.dates
			)
			return this.$store.state.parametersStore.dates;
		},
	},

	methods: {
		async getPDF(repoId) {
			await api
				.getPDFUrl(repoId)
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'file.pdf');
					document.body.appendChild(link);
					link.click();
				}).catch(console.error)
		},

		toggleSelectAll() {
			if (this.areSelected) {
				this.installations = this.installations.map((installation) => {
					return { ...installation, ...{ checked: false } };
				});
				this.installations[0].checked = true;
			} else
				this.installations = this.installations.map((installation) => {
					return { ...installation, ...{ checked: true } };
				});
		},

		getColumns(group) {
			// Catch column group

			return this.constants.columns.filter((column) =>
				column.group === group && column.show_dashboard.includes(this.target_menu)
			);
		},

		isGroupSelected(group) {
			return this.selectedGroups.includes(group);
		},

		toggleInstallation(index) {
			if (
				this.installations.filter((x) => x.checked).length <= 1 &&
				this.installations[index].checked
			)
				this.installations[index].checked = 1;
			else {
				this.installations[index].checked = !this.installations[index].checked;
				this.$store.commit("SET_INSTALLATIONS", this.installations);
			}
		},

		toggleGroupSelection(group, event) {
			if (this.isGroupSelected(group)) {
				if (this.selectedGroups.length > 1)
					this.selectedGroups = this.selectedGroups.filter((e) => e !== group);
				else event.preventDefault();
			} else this.selectedGroups.push(group);
		},

		isFirstColumnOfGroup(column) {
			if (column.key === "action_list") return true;
			const group = column.group;
			const columns = this.getColumns(group);
			return !columns.indexOf(column);
		},

		goToInstallation(installation, columnKey) {
			if (columnKey !== "rapport") {
				this.$store.dispatch("setInstallationAuditDate", {
					start_date: installation.audit_start_date,
					end_date: installation.audit_end_date
				});

				this.$store.dispatch("setInstallationMaxDates", {
					start_date: installation.audit_start_date,
					end_date: installation.audit_end_date
				});

				this.$store.dispatch("setShowDateSelector", { show: true });
				this.$store.commit("SET_EXPERT_PDM", this.current_pdm);

				this.$store.commit("SET_GEO_PDM", '');

				this.$store.commit("SET_CUR_INSTALL_ID", installation.id);
				const path = `/installations/show/calepinage-agencement/${installation.id}`;
				if (this.$route.path !== path) this.$router.push(path);
			}
		},

		getInstallationList() {
			this.loading = true

			return this.$store
				// .dispatch("getInstallationList", {'analysis_mode': this.analysis_mode})
				.dispatch("getInstallationList")
				.then(async () => {
					this.loading = false;
					this.selectedColumns = this.constants.columns.filter((column) =>
						column.show_dashboard.includes(this.target_menu)
					);
				});
		},

		...mapMutations(["SET_INSTALLATIONS", "SET_SHOW_DATE_SELECTOR"]),

		toggleCreate() {
			this.openCreate = !this.openCreate
		},

		async toggleModal() {
			await this.getInstallationList()
			this.$forceUpdate()
			this.dataToGive = null
			if (this.openCreate) {
				this.toggleCreate()
			}
			this.createAudit = !this.createAudit
			
		},

		async useDraft(brouillon) {
			await this.toggleModal()
			this.dataToGive = brouillon
		},

		openModify(installation) {
            this.modifier = true
			this.installId = installation.id
        },

        async closeModify() {
			await this.getInstallationList()
			this.$forceUpdate()
            this.modifier = false
			
        }
	},

	async mounted() {
		this.target_menu = (this.$route.name === 'dashboard-audits') ? 'audit' : 'continuous'
		this.getInstallationList()
	},

};
</script>

<style>
.theme--light.v-data-table>.v-data-table__wrapper,
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr {
	border-radius: 5px;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr {
	background-color: rgb(214, 214, 214);
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
	color: #504F4F;
	padding-top: 10px;
	padding-bottom: 10px;
}

.theme--light.v-data-table .v-data-table-header th.sortable:hover,
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable.active {
	color: #000000;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.theme--light.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
	font-size: .775rem;
	height: 55px;
}

.disabled {
	background-color: lightgray;
	pointer-events: none;
}
</style>
